import React from 'react';
import { IconProps } from '../types';
import styles from '../Icons.module.scss';
import { getSvgDimensions } from '../utils';
import { DEFAULT_ICON_SIZE } from '../constants';

const EligibilityIcon: React.FC<IconProps> = ({
    size = DEFAULT_ICON_SIZE,
    width,
    height,
    color = styles.naviIconDefaultColor,
    ...restProps
}) => {
    const { svgHeight, svgWidth } = getSvgDimensions({ height, width, size });
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={svgWidth}
            height={svgHeight}
            fill="none"
            viewBox="0 0 24 24"
            {...restProps}
        >
            <path
                fill={color}
                fillRule="evenodd"
                d="M18.998.997h-14c-1.66 0-3 1.35-3 3v16c0 1.66 1.34 3 3 3h14c1.66 0 3-1.34 3-3v-16c0-1.65-1.34-3-3-3zm1.14 7.88c0 1.11-.89 2-1.99 2H6.068c-1.1 0-1.99-.89-1.99-2v-3.72c0-1.1.9-2 1.99-2h12.08c1.11 0 1.99.9 1.99 2v3.72zm-1.642 7.8a.7.7 0 100-1.4h-4.6a.7.7 0 100 1.4h4.6zm.7 1.67a.7.7 0 01-.7.7h-4.6a.7.7 0 110-1.4h4.6a.7.7 0 01.7.7zm-9.263-2.35a.7.7 0 10-.99-.99l-1.13 1.13-1.13-1.13a.7.7 0 10-.99.99l1.13 1.13-1.132 1.133a.7.7 0 10.99.99l1.133-1.133 1.132 1.132a.7.7 0 10.99-.99l-1.132-1.132 1.13-1.13z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
};

export default React.memo(EligibilityIcon);
